import React, { useEffect, useRef } from 'react';

import MessageInput from './composer/message_input';
import { Card } from '@buildoutinc/blueprint-react/ui/Card';
import ConversationStarters from './transcript/conversation_starters';
import { Transcript } from './transcript/transcript';
import { useConversationContext } from './conversation_context';

import './styles.scss';

interface Props {
  pinned?: React.ReactNode;
}

// Renders into a Card the surface owns, so each one can put its own chrome above this.
export function Conversation({ pinned }: Props) {
  const {
    attachments, busy, input, messages, recording, restoring, resuming, send, sttSupported, visible,
    addAttachments, changeInput, removeAttachment, submit, toggleMic,
  } = useConversationContext();

  const bodyRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bodyRef.current?.scrollTo({ top: bodyRef.current.scrollHeight });
  }, [messages, busy, visible]);

  return (
    <>
      <Card.Body className="ai-assistant-chat d-flex flex-column flex-grow-1 overflow-auto p-5" ref={bodyRef}>
        <Transcript
          empty={<ConversationStarters onSelect={send} />}
          messages={messages}
          restoring={restoring}
        />
      </Card.Body>

      {pinned}

      <Card.Footer className="bg-transparent border-top-0 pt-0 px-4 pb-4">
        <MessageInput
          attachments={attachments}
          disabled={resuming}
          input={input}
          recording={recording}
          sttSupported={sttSupported}
          onAddAttachments={addAttachments}
          onInputChange={changeInput}
          onMicClick={toggleMic}
          onRemoveAttachment={removeAttachment}
          onSubmit={submit}
        />
        <p className="text-muted small text-center mt-4 mb-0">AI-generated content may be inaccurate.</p>
      </Card.Footer>
    </>
  );
}
